import React, { useState, useCallback } from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { user } from '~data/selectors/user';
import { tfaRevoke } from '~data/actions/user';

import { Layout, Label, Input, Button, ButtonRow, Modal, ModalHeader as Header } from '~ui';
import { Error } from '~co/overlay/dialog';

export default function SettingsTfaRevoke() {
  const dispatch = useDispatch();
  const {
    tfa: { enabled },
  } = useSelector(user);
  const [confirm, setConfirm] = useState(false);
  const [code, setCode] = useState('');

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      setConfirm(false);
      dispatch(tfaRevoke({ code }, () => {}, Error));
    },
    [code, dispatch],
  );

  if (!enabled) return null;

  return (
    <ButtonRow>
      <Button variant='outline' onClick={() => setConfirm(true)}>
        {t.s('disable')}
      </Button>

      {confirm ? (
        <Modal onClose={() => setConfirm(false)}>
          <Header title={t.s('disableTfa')} />

          <form onSubmit={onSubmit}>
            <Layout>
              <Label>Enter authentication app code or recovery code</Label>
              <Input
                autoFocus
                required
                autoComplete='one-time-code'
                type='text'
                name='code'
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />

              <ButtonRow>
                <Button type='submit' disabled={!code}>
                  {t.s('disable')}
                </Button>

                <Button variant='outline' onClick={() => setConfirm(false)}>
                  {t.s('cancel')}
                </Button>
              </ButtonRow>
            </Layout>
          </form>
        </Modal>
      ) : null}
    </ButtonRow>
  );
}
